import React, { useState,useEffect } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
function CompanyAdsRequestsView() {
    const ID = Cookies.get("log_id");
    const [ads,setAds] = useState([]);
    function Fetch_Company_Ads() {
        axios.get(`${url.path}/fetch_company_ads/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var ads = res.data.ads;
                setAds([])
                ads.map((e)=>{
                    setAds((prevState)=>[
                        ...prevState, e
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        Fetch_Company_Ads();
    }, [])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = ads.filter((item) =>
      item.Product_Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    return(
        <>
        <CompanyNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>All Ads</h3>
            </center>
            <div className="search-container">
                <input
                type="text"
                placeholder="Search..."
                onKeyUp={searchTable}
                className="search-input"
                id="search"
                />
            </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Product Name</th>
            <th>Company Name</th>
            <th>Duration</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {ads.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Product_Name}</td>
              <td>{i.Company_Name}</td>
              <td>{i.Duration}</td>
              <td>{i.Start_Date}</td>
              <td>{i.End_Date}</td>
              <td>{i.Admin_Approved_Status}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default CompanyAdsRequestsView;